module.exports = __webpack_public_path__ + "static/media/DesignSmartSlide05.ced245fc.jpg";